import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import MeditationDashboard from './MeditationDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyMeditationDashboard } from './companyMeditationApi';

/** Company Meditation Sounds → Dashboard, scoped to this company. */
const CMeditationDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyMeditationDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Meditation Sounds | Shoorah</title>
      </Helmet>
      <MeditationDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CMeditationDashboard;
